import { render, staticRenderFns } from "./ContractsPage.vue?vue&type=template&id=6fdbdd3a&scoped=true"
import script from "./ContractsPage.vue?vue&type=script&lang=js"
export * from "./ContractsPage.vue?vue&type=script&lang=js"
import style0 from "./ContractsPage.vue?vue&type=style&index=0&id=6fdbdd3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdbdd3a",
  null
  
)

export default component.exports